module.exports = __webpack_public_path__ + "media/images/badge/apprendista_secondary-e047eba54eff572c5832b3de0939909f.png";